import { cn } from "@repo/shared/utils";
import { Label } from "./Label";
import { Checkbox, type CheckboxProps } from "./Checkbox";
import { InputInfo } from "./InputInfo";
import { forwardRef } from "react";

export interface CheckboxInputProps extends CheckboxProps {
  label?: React.ReactNode;
  labelStyle?: string;
  wrapperStyle?: string;
  containerStyle?: string;
  orientation?: "horizontal" | "vertical";
  error?: boolean;
  errorMessage?: string;
}

export const CheckboxInput = forwardRef<HTMLDivElement, CheckboxInputProps>(
  (
    {
      label,
      labelStyle,
      wrapperStyle,
      containerStyle,
      orientation,
      error,
      errorMessage,
      ...props
    },
    ref
  ) => {
    return (
      <div ref={ref} className={cn("flex flex-col gap-2 w-full", wrapperStyle)}>
        <label
          className={cn(
            "flex gap-y-1 mt-1.5",
            orientation === "horizontal"
              ? "flex-row items-center gap-x-3"
              : "flex-col-reverse",
            props.disabled ? "cursor-not-allowed" : "cursor-pointer",
            containerStyle
          )}
        >
          <Checkbox {...props} />

          {label && <Label className={labelStyle} label={label} as="div" />}
        </label>
        {error && errorMessage && <InputInfo info={errorMessage} />}
      </div>
    );
  }
);
